import BottomSheet from "@components/Popup/BottomSheet";
import Dialog, {AriaDialogProps} from "@components/Popup/Dialog";
import Frame from "@components/Popup/Frame";
import Overlay from "@components/Popup/Overlay";
import React, {PropsWithChildren} from "react";

import useMediaQuery from "../../../useMediaQuery";

export type Props = {
  // True if the popup is showing, and false if not.
  open: boolean;
  // Callback executed if the popup gets closed.
  onClose: () => void;
  // Max width of the modal as a tailwind string
  maxWidth?: string;
} & AriaDialogProps;

/**
 * A popup renders as a BottomSheet on mobile or an Overlay on web.
 *
 * This is designed for cases where the child components inside the popup window don't
 * change across screen sizes.
 */
const Popup = ({children, maxWidth, open, onClose, ...ariaProps}: PropsWithChildren<Props>) => {
  const isMobile = useMediaQuery("sm");
  return isMobile ? (
    <BottomSheet onClose={onClose} open={open}>
      <Frame onClose={onClose}>{children}</Frame>
    </BottomSheet>
  ) : (
    <Overlay open={open}>
      <Dialog
        {...ariaProps}
        className={`${maxWidth ?? "max-w-2xl"} rounded-3xl p-0`}
        onClose={onClose}
        open={open}
      >
        <Frame onClose={onClose}>{children}</Frame>
      </Dialog>
    </Overlay>
  );
};

export default Popup;
